
import { createRouteMeta, createPortalCmMeta } from './metaCreators'

export class ProtobufMessageCreator {
  constructor (transportMessageCreator, routeMessageCreator) {
    if (!transportMessageCreator || !routeMessageCreator) {
      throw new Error('Missing parameters!')
    }
    this.transportMessageCreator = transportMessageCreator
    this.routeMessageCreator = routeMessageCreator

    this._createRouteMeta = createRouteMeta
    this._createPortalCmMeta = createPortalCmMeta
  }

  createGetIceInfoRequest = () => {
    const getIceInfoRequest = this._createGetIceInfoRequest()
    const msg = this.transportMessageCreator.create(getIceInfoRequest)
    return msg
  }

  createResolveAgentAddressRequest = (sessionKey) => {
    const resolveAgentAddressRequest = this._createResolveAgentAddressRequest(sessionKey)
    const msg = this.transportMessageCreator.create(resolveAgentAddressRequest)
    return msg
  }

  createResolveInstalledAgentAddressRequest = (id) => {
    const resolveInstalledAgentAddressRequest = this._createResolveInstalledAgentAddressRequest(id)
    const msg = this.transportMessageCreator.create(resolveInstalledAgentAddressRequest)
    return msg
  }

  createGetUserDetailsFromTokenRequest = (token) => {
    const getUserDetailsFromTokenRequest = this._createGetUserDetailsFromTokenRequest(token)
    const msg = this.transportMessageCreator.create(getUserDetailsFromTokenRequest)
    return msg
  }

  createOffer = (clientDescription, token, agentAddress) => {
    const body = this._createOffer(clientDescription, token)
    const routeMessage = this.routeMessageCreator.create(agentAddress, body)
    const transportMessage = this.transportMessageCreator.create(routeMessage)

    return transportMessage
  }

  createICECandidates = (rtcIceCandidate, agentAddress) => {
    const body = this._createICECandidates(rtcIceCandidate)
    const routeMessage = this.routeMessageCreator.create(agentAddress, body)
    const transportMessage = this.transportMessageCreator.create(routeMessage)

    return transportMessage
  }

  createAgentDetailsRequest = (agentAddress) => {
    const body = this._createAgentDetailsRequest()
    const routeMessage = this.routeMessageCreator.create(agentAddress, body)
    const transportMessage = this.transportMessageCreator.create(routeMessage)

    return transportMessage
  }

  // ... private

  _createGetIceInfoRequest () {
    const message = new proto.netop.rc.portal.cm.GetIceInfoRequest()
    message.setNetopMessageType('netop.rc.portal.cm.GetIceInfoRequest')
    message.setMeta(this._createPortalCmMeta())
    const messageBinary = message.serializeBinary()

    return messageBinary
  }

  _createResolveAgentAddressRequest (sessionKey) {
    const msg = new proto.netop.rc.route.ResolveAgentAddressRequest()
    msg.setNetopMessageType('netop.rc.route.ResolveAgentAddressRequest')
    msg.setMeta(this._createRouteMeta())
    msg.setSessionKey(sessionKey)
    const msgBinary = msg.serializeBinary()

    return msgBinary
  }

  _createResolveInstalledAgentAddressRequest (id) {
    const msg = new proto.netop.rc.route.ResolveAddressRequest()
    msg.setNetopMessageType('netop.rc.route.ResolveAddressRequest')
    msg.setMeta(this._createRouteMeta())
    msg.setEntityId(id)
    const msgBinary = msg.serializeBinary()

    return msgBinary
  }

  _createGetUserDetailsFromTokenRequest (token) {
    const msg = new proto.netop.rc.portal.cm.GetUserDetailsFromTokenRequest()
    msg.setNetopMessageType('netop.rc.portal.cm.GetUserDetailsFromTokenRequest')
    msg.setMeta(this._createPortalCmMeta())
    msg.setToken(token)
    const msgBinary = msg.serializeBinary()

    return msgBinary
  }

  _createOffer (description, token) {
    const offer = new proto.netop.rc.signaling.Offer()
    offer.setMessageType(proto.netop.rc.signaling.SignalingMessageType.OFFER)
    offer.setSdp(description)
    offer.setUserToken(token)
    const msgBinary = offer.serializeBinary()

    return msgBinary
  }

  /**
   * @param {string} candidate RTCIceCandidate.toJSON() or empty string
   */
  _createICECandidates (rtcIceCandidate) {
    const msg = new proto.netop.rc.signaling.ICECandidates()
    msg.setMessageType(proto.netop.rc.signaling.SignalingMessageType.ICE_CANDIDATES)
    msg.setMid(rtcIceCandidate.sdpMid)
    msg.setSdp(rtcIceCandidate.candidate)
    msg.setMlineindex(rtcIceCandidate.sdpMLineIndex)

    const msgBinary = msg.serializeBinary()

    return msgBinary
  }

  _createAgentDetailsRequest () {
    const msg = new proto.netop.rc.signaling.AgentDetailsRequest()
    msg.setMessageType(proto.netop.rc.signaling.SignalingMessageType.DETAILS_REQUEST)

    const msgBinary = msg.serializeBinary()

    return msgBinary
  }

  _isString (variable) {
    return (typeof variable === 'string' || variable instanceof String)
  }

}
